import type { TOC } from '@ember/component/template-only';
import { htmlSafe } from '@ember/template';
import { PrismIcon } from '@mylighthouse/prism-ember';
import { t } from 'ember-intl';
import type { SmartInsightDayRecommendationEntry } from 'lumen/models';

import styles from './smart-insight-recommendation-list.module.css';

interface GeneralSmartInsightsDetailViewSmartInsightRecommendationListSignature {
  Args: {
    entries: SmartInsightDayRecommendationEntry[];
  };
}

const GeneralSmartInsightsDetailViewSmartInsightRecommendationList: TOC<GeneralSmartInsightsDetailViewSmartInsightRecommendationListSignature> =
  <template>
    <div
      class="flex flex-col gap-200"
      data-test-id="smart-insight-recommendation-list"
    >
      <h4>
        {{t "smart_insights.detail_view.recommendations"}}
      </h4>

      {{#each @entries as |entry|}}
        <div
          class="{{styles.recommendation-card}}
            rounded-200 flex flex-row gap-400 px-400 py-300"
          data-test-id="smart-insight-recommendation-entry"
        >
          <PrismIcon
            @color="on-intelligence"
            @name={{entry.iconName}}
            @size="small"
            data-test-id="smart-insight-recommendation-entry-icon"
          />

          <p
            class="text-300--regular text-intelligence-emphasis"
            data-test-id="smart-insight-recommendation-entry-text"
          >
            {{htmlSafe entry.formattedText}}
          </p>
        </div>
      {{/each}}
    </div>
  </template>;

export default GeneralSmartInsightsDetailViewSmartInsightRecommendationList;
